import BusinessFooter from '@components/BusinessFooter';
import useProject from '@hooks/useProject';
import { useMemo } from 'react';

function PaymentFooter() {
  const project = useProject();
  const content = useMemo<string>(() => {
    switch (project?.businessProfile?.paymentAgencyType) {
      case 'WALDPAYMENTS':
        return '(주)발트페이먼츠\n'
            + '대표자 : 최영우\n'
            + '사업자등록번호 : 141-81-25936\n'
            + '통신판매업신고번호 : 제2021-성남분당B-0399호\n'
            + '주소 : 경기도 성남시 분당구 방아로 8, 4층(이매동, 매송빌딩)\n'
            + '이메일 : help@waldlust.co.kr\n\n'
            + '- 발트페이먼츠는 통신판매중개자이며, 통신판매의 당사자가 아닙니다. \n'
            + '- 따라서 발트페이먼츠는 상품거래정보 및 거래에 대한 책임을 지지 않습니다.';
      case 'WALDLUST':
        return '(주)발트루스트\n'
                + '대표자 : 최영우\n'
                + '사업자등록번호 : 144-81-16853\n'
                + '통신판매업신고번호 : 제2020-성남분당A-0263호\n'
                + '주소 : 경기도 성남시 분당구 성남대로779번길 6, 2층, 4층(이매동, KT분당빌딩)\n'
                + '이메일 : help@waldlust.co.kr\n\n'
                + '- 발트루스트는 통신판매중개자이며, 통신판매의 당사자가 아닙니다.\n'
                + '- 따라서 발트루스트는 상품거래정보 및 거래에 대한 책임을 지지 않습니다.';
      default: return '';
    }
  }, [project]);
  return (
        <BusinessFooter>
            {content}
        </BusinessFooter>
  );
}

export default PaymentFooter;
